/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAgentSkillVersionsPathParams = NonNullable<operations['listAgentSkillVersions']['parameters']['path']>;

export type ListAgentSkillVersionsQueryParams = NonNullable<
  operations['listAgentSkillVersions']['parameters']['query']
>;

export interface Input extends ListAgentSkillVersionsPathParams {
  apiVersion?: string;
  query?: ListAgentSkillVersionsQueryParams;
}

export async function listAgentSkillVersions(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-configs/skills/{skillKey}/versions', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
